export default {
  ready: 'ready',
  canRemoveMultiTask: 'canRemoveMultiTask',
  canSelectCriticalChain: 'canSelectCriticalChain',
  canDefineBufferSize: 'canDefineBufferSize',
  finished: 'finished',
}
